<template>
  <div>
    <agile-table
      :data-type="'priceListDefault'"
      :table-meta="tableMeta"
      :data="priceListDefault"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button @clicked="openPriceListDefaultModal(0)" />
    <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import PriceListDefaultModal from '@/components/modals/PriceListDefaultModal'
import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    NewButton,
    PriceListDefaultModal,
    AgileTable
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-list-ol'
      },

      filterMeta: [{
        fieldId: 'year',
        type: 'string',
        label: 'År'
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'year',
          label: 'År'
        },
        {
          fieldId: 'comment',
          label: 'Kommentar'
        },
        {
          fieldId: 'numberOfLines',
          label: 'Antal priser definierade',
          disableOrdering: true
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updatePriceList',
          iconClass: 'fal fa-pen'
        },
        {
          label: 'Ta bort',
          action: 'deletePriceList',
          iconClass: 'fal fa-trash-alt'
        }]
      }
    }
  },
  watch: {
    'priceListDefault.filter': {
      handler () {
        this.priceListDefault.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      priceListDefault: state => state.priceListDefault.all
    })
  },
  methods: {
    ...mapActions('priceListDefault', ['initialize', 'getListData', 'delete']),

    rowAction (action, priceList) {
      switch (action) {
        case 'updatePriceList':
          this.openPriceListDefaultModal(priceList.priceListDefaultId)
          break
        case 'deletePriceList':
          this.$confirm('Radera prislista', 'Är du säker på att du vill radera prislistan för ' + priceList.year + '?').then((result) => {
            if (result.value) {
              this.delete(priceList.priceListDefaultId)
            }
          })
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, priceList) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    openPriceListDefaultModal (id) {
      this.$panel(PriceListDefaultModal, { id })
    }
  },

  created () {
    this.initialize()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/SuperAdmin/PriceListsDefaultPage.vue